import '@testing-library/jest-dom';
import { fireEvent, render, screen, waitFor } from '@testing-library/react';
import userEvent from '@testing-library/user-event';

import { AccordionCard } from './AccordionCard';

describe('AccordionCard', () => {
  it('should render', () => {
    render(<AccordionCard title="Test Accordion Card" content={'TestComponent'} expanded />);
    expect(screen.getByText('Test Accordion Card')).toBeInTheDocument();
    expect(screen.getByText('TestComponent')).toBeInTheDocument();
  });

  it('should display content when expanded by default', () => {
    render(<AccordionCard title="Test Accordion Card" content={'TestComponent'} expanded />);
    expect(screen.getByText('Test Accordion Card')).toBeInTheDocument();
    expect(screen.getByText('TestComponent')).toHaveClass('accordion-card__content--expanded');
  });

  it('should toggle content visibility on click', () => {
    render(<AccordionCard title="Test Accordion Card" content={'TestComponent'} />);
    const titleElement = screen.getByText('Test Accordion Card');
    const contentElement = screen.getByText('TestComponent');
    expect(titleElement).toBeInTheDocument();
    fireEvent.click(titleElement);
    expect(contentElement).toHaveClass('accordion-card__content--expanded');
    fireEvent.click(titleElement);
    expect(contentElement).not.toHaveClass('accordion-card__content--expanded');
  });

  it('should toggle content visibility on Enter key press', async () => {
    render(<AccordionCard title="Test Accordion Card" content={'TestComponent'} />);
    const titleElement = screen.getByRole('button');
    const contentElement = screen.getByText('TestComponent');
    titleElement.focus();
    await userEvent.keyboard('[Enter]');
    await waitFor(() => {
      expect(contentElement).toHaveClass('accordion-card__content--expanded');
    });
    await userEvent.keyboard('[Enter]');
    await waitFor(() => {
      expect(contentElement).not.toHaveClass('accordion-card__content--expanded');
    });
  });

  it('should toggle content visibility on Space key press', async () => {
    render(<AccordionCard title="Test Accordion Card" content={'TestComponent'} />);
    const titleElement = screen.getByRole('button');
    const contentElement = screen.getByText('TestComponent');
    titleElement.focus();
    await userEvent.keyboard('[Space]');
    await waitFor(() => {
      expect(contentElement).toHaveClass('accordion-card__content--expanded');
    });
    await userEvent.keyboard('[Space]');
    await waitFor(() => {
      expect(contentElement).not.toHaveClass('accordion-card__content--expanded');
    });
  });
});
